import { useWishlist } from "@/context/WishlistContext";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Link } from "react-router-dom";

export default function WishlistList() {
  const wishlist = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/wishlist")
      .then(({ data }) => setProducts(data))
      .catch((err) => console.warn(err))
      .finally(() => setLoading(false));
  }, [wishlist?.ids?.length]);

  if (loading) return <p className="font-mono-b p-6" data-testid="wishlist-loading">LOADING...</p>;
  if (products.length === 0) return (
    <div className="border-2 border-dashed border-black p-12 text-center font-mono-b" data-testid="wishlist-empty">
      Nothing saved yet. Tap the heart on any product. <Link to="/shop" className="underline font-bold ml-1">Shop the drop</Link>.
    </div>
  );

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-testid="wishlist-grid">
      {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
    </div>
  );
}
